module.exports = __webpack_public_path__ + "static/media/SpaceMono-Regular.52eb73db.ttf";